import {ZodIssue} from 'zod';

export class ZodValidationError extends Error {
    errors: ZodIssue[];

    constructor(errors: ZodIssue[]) {
        super('Zod validation error');
        this.errors = errors;
    }
}
